import React from "react";

export const Ellipse1 = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="true"
      viewBox="0 0 14 14"
    >
      <circle
        cx="6.696"
        cy="6.696"
        r="5.696"
        fillRule="evenodd"
        stroke="#FBFBFB"
        strokeWidth="2"
      ></circle>
    </svg>
  );
};
